import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useAuth } from '../contexts/AuthContext';
import './ManagerInviteRegister.css';

const ManagerInviteRegister = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();

  const [checking, setChecking] = useState(true);
  const [valid, setValid] = useState(false);
  const [prefilledEmail, setPrefilledEmail] = useState('');
  const [form, setForm] = useState({
    first_name: '',
    last_name: '',
    email: '',
    password: '',
  });
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    const validateInvite = async () => {
      try {
        const response = await axios.get(`/api/auth/manager-invites/${token}/`);
        setValid(!!response.data.valid);
        const incomingEmail = response.data.email || '';
        setPrefilledEmail(incomingEmail);
        if (incomingEmail) {
          setForm((prev) => ({ ...prev, email: incomingEmail }));
        }
      } catch (error) {
        const message = error.response?.data?.error || 'Ссылка недействительна или истекла';
        toast.error(message);
        setValid(false);
      } finally {
        setChecking(false);
      }
    };
    validateInvite();
  }, [token]);

  const onChange = (field) => (e) => {
    setForm((prev) => ({ ...prev, [field]: e.target.value }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const response = await axios.post(`/api/auth/manager-register/${token}/`, form);
      loginWithToken(response.data.token, response.data.user);
      toast.success('Регистрация завершена');
      navigate('/webinars');
    } catch (error) {
      toast.error(error.response?.data?.error || 'Ошибка регистрации');
    } finally {
      setSubmitting(false);
    }
  };

  if (checking) {
    return <div className="invite-register-page"><div className="invite-register-card">Проверка ссылки...</div></div>;
  }

  if (!valid) {
    return (
      <div className="invite-register-page">
        <div className="invite-register-card">
          <h2>Ссылка недействительна</h2>
          <p>Попросите администратора отправить новую ссылку приглашения.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="invite-register-page">
      <div className="invite-register-card">
        <h2>Регистрация менеджера</h2>
        <p className="invite-register-hint">Заполните данные для входа в систему.</p>
        <form onSubmit={onSubmit} className="invite-register-form">
          <label>Имя</label>
          <input value={form.first_name} onChange={onChange('first_name')} placeholder="Имя" />

          <label>Фамилия</label>
          <input value={form.last_name} onChange={onChange('last_name')} placeholder="Фамилия" />

          <label>Email</label>
          <input
            type="email"
            value={form.email}
            onChange={onChange('email')}
            placeholder="manager@company.com"
            required
            disabled={!!prefilledEmail}
          />

          <label>Пароль (минимум 8 символов)</label>
          <input
            type="password"
            value={form.password}
            onChange={onChange('password')}
            placeholder="********"
            required
            minLength={8}
          />

          <button type="submit" className="btn btn-primary" disabled={submitting}>
            {submitting ? 'Регистрация...' : 'Зарегистрироваться'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ManagerInviteRegister;
